/**
 * api接口统一管理
 */
import {axiosInstance} from "./http";
//职位列表
export const jobList = obj => axiosInstance.get('/blade-recruit/demand/portalList',{params:obj})
//职位详情
export const jobDetail = obj => axiosInstance.get('/blade-recruit/demand/detail',{params:obj})

//职业列表
export const portalList = obj => axiosInstance.get('/blade-recruit/postconfig/portalList',{params:obj})

//机构详情
export const hospitalDetail = obj => axiosInstance.get('/blade-clinic/hospital/detail',{params:obj})
//我的简历
export const resumelDetail = obj => axiosInstance.get('/blade-recruit/resume/getMySelf',{params:obj})
//简历详情
export const resumelDetailInfo = obj => axiosInstance.get('/blade-recruit/resume/detail',{params:obj})
//简历提交
export const resumelSubmit = obj => axiosInstance.post('/blade-recruit/resume/submit',obj)
//投送简历
export const sendResume = obj => axiosInstance.post('/blade-recruit/resumestatusorg/submit',obj)
//邀请面试
export const sendInvite = obj => axiosInstance.post('/blade-recruit/resumestatusorg/invite',obj)

//最后一次工作详情
export const lastworkDetail = obj => axiosInstance.get('/blade-recruit/lastwork/getMyLastWork',{params:obj})
//最后一次工作详情
export const lastworkDetailInfo = obj => axiosInstance.get('/blade-recruit/lastwork/detail',{params:obj})
//最后一次工作提交
export const lastworkSubmit = obj => axiosInstance.post('/blade-recruit/lastwork/submit',obj)


//岗位列表
export const postSelect = obj => axiosInstance.get('/blade-system/post/select',{params:obj})

//人才列表
export const getTalentList = obj => axiosInstance.get('/blade-recruit/resume/getTalentList',{params:obj})

//人才详情
export const getTalentDetail = obj => axiosInstance.get('/blade-recruit/resume/getDetail',{params:obj})

//已投递简历
export const getDeliveryList = obj => axiosInstance.get('/blade-recruit/resumestatusorg/deliveryList',{params:obj})

//邀约详情
export const resumestatusorgDetail = obj => axiosInstance.get('/blade-recruit/resumestatusorg/detail',{params:obj})

//处理邀请
export const sendResumeUpdate = obj => axiosInstance.post('/blade-recruit/resumestatusorg/update',obj)

//收藏
export const relationshipSubmit = obj => axiosInstance.post('/blade-collect/relationship/submit',obj)

//收藏列表
export const pageCollection = obj => axiosInstance.get('/blade-recruit/demand/pageCollection',{params:obj})

//取消收藏
export const deleteCollection = obj => axiosInstance.get('/blade-collect/relationship/delete',{params:obj})

//简历更新
export const resumestatusorgUpdate = obj=> axiosInstance.post('/blade-recruit/resumestatusorg/update',obj)